/* Wybierz potrzebę: filtert de behoefte-kaarten op diersoort, onthoudt de keuze en gebruikt de naam uit de hero. */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('need-picker')) return;
  var KEY = 'lapusie:animal';
  function read() { try { return localStorage.getItem(KEY) || 'all'; } catch (e) { return 'all'; } }
  function write(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  customElements.define('need-picker', class extends HTMLElement {
    connectedCallback() {
      this.chips = Array.from(this.querySelectorAll('[data-np-animal]'));
      this.items = Array.from(this.querySelectorAll('[data-np-for]'));
      this.status = this.querySelector('[data-np-status]');
      this.empty = this.querySelector('[data-np-empty]');
      this.heading = this.querySelector('[data-np-heading]');
      var self = this;
      this.chips.forEach(function (c) {
        c.addEventListener('click', function () { self.select(c.getAttribute('data-np-animal'), true); });
      });
      var saved = read();
      if (!this.chips.some(function (c) { return c.getAttribute('data-np-animal') === saved; })) saved = 'all';
      this.select(saved, false);
      this.name();
      document.addEventListener('lapusie:pet-change', function () { self.name(); });
    }
    name() {
      var pet = window.LapusiePet && window.LapusiePet.get();
      var tpl = this.getAttribute('data-heading-named');
      if (!this.heading) return;
      this.heading.textContent = pet && pet.name && tpl ? tpl.replace('{name}', pet.name) : this.heading.getAttribute('data-default');
    }
    select(key, save) {
      var shown = 0, label = '';
      this.chips.forEach(function (c) {
        var on = c.getAttribute('data-np-animal') === key;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) label = c.textContent.trim();
      });
      this.items.forEach(function (li) {
        var ok = key === 'all' || li.getAttribute('data-np-for').indexOf(key) > -1;
        li.classList.toggle('is-dim', !ok);
        li.querySelector('a').setAttribute('tabindex', ok ? '0' : '-1');
        if (ok) shown++;
      });
      if (this.empty) this.empty.hidden = shown > 0;
      if (this.status) this.status.textContent = key === 'all' ? '' : label + ': ' + shown;
      if (save) write(key);
    }
  });
})();
